import React from 'react';
import cn from 'classnames/bind';
import styles from './Spinner.scss';

const cx = cn.bind(styles);

const Spinner = ({children, isLoading, className}) => {
  return (
    <div className={cx(styles.Spinner, className)}>
      {
        isLoading ?
        <div className={styles.doubleBounce}>
          <div className={styles.doubleBounce1} />
          <div className={styles.doubleBounce2} />
        </div> :
        null
      }
      <div className={cx(styles.Content, {Blur: isLoading})}>
        {children}
      </div>
    </div>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/common/Spinner/Spinner.js